import type { SVGProps } from "react";

export function BalconyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 4.5C6.25 3.5335 7.0335 2.75 8 2.75H16C16.9665 2.75 17.75 3.5335 17.75 4.5V13.75H20V15.25H19.25V20.25H20V21.75H4V20.25H4.75V15.25H4V13.75H6.25V4.5ZM7.25 15.25V20.25H6.25V15.25H7.25ZM8.75 20.25V15.25H9.75V20.25H8.75ZM11.25 20.25H12.75V15.25H11.25V20.25ZM14.25 15.25V20.25H15.25V15.25H14.25ZM16.25 13.75V10.25H12.75V13.75H16.25ZM11.25 13.75H7.75V10.25H11.25V13.75ZM12.75 8.75H16.25V4.5C16.25 4.36193 16.1381 4.25 16 4.25H12.75V8.75ZM11.25 4.25V8.75H7.75V4.5C7.75 4.36193 7.86193 4.25 8 4.25H11.25ZM16.75 15.25V20.25H17.75V15.25H16.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
